export default __webpack_public_path__ + "static/media/bg2.acc45f0a.jpg";